<template>
  <div>
    <HeaderGestion/>
    <SubHeader
      nombre="Gestión de usuarios"
      precedente="Hola"
      color= "2"
    />
    <FormUsuarios/>
  </div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeader from '../components/SubHeader.vue'
import FormUsuarios from '../components/FormUsuarios.vue'
export default {
  components: { HeaderGestion, SubHeader, FormUsuarios },
  name: 'GestionUsuarios'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
